import { IRequest } from "../interfaces/authentication.interface";
import { ICountry } from "../interfaces/countries.interface";
import { strapiRequest } from "./requests.service";

export const getCountries = async (locale: string): Promise<IRequest<ICountry[]>> => {
    try {
        const query = `
            query Countries($filters: CountryFiltersInput, $locale: I18NLocaleCode) {
                countries(filters: $filters, locale: $locale) {
                    isoCode
                    entityId
                    name
                }
            }`;

        const variables = {
            filters: {
                active: {
                    eq: true
                }
            },
            locale
        };

        const response = await strapiRequest.post<{ data: { countries: ICountry[] } }>(
            `/graphql`,
            {
                operationName: "Countries",
                query,
                variables
            }
        );

        return {
            success: true,
            data: response.data.data.countries ?? { countries: [] }
        };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};
